(() => {
  const PRODUCT_HANDLE = "tri-zone-oven";
  const currentHandle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];

  if (currentHandle !== PRODUCT_HANDLE) return;

  let isSubmitting = false;

  const shopifyRoot = () => {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  };

  const setBusy = (form, busy) => {
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
      if (busy) {
        button.setAttribute("aria-busy", "true");
        button.setAttribute("aria-disabled", "true");
      } else {
        button.removeAttribute("aria-busy");
        button.removeAttribute("aria-disabled");
      }
    });
  };

  const showError = (form, message) => {
    let errorBox = form.querySelector("[data-trizone-checkout-error]");

    if (!errorBox) {
      errorBox = document.createElement("div");
      errorBox.dataset.trizoneCheckoutError = "true";
      errorBox.setAttribute("role", "alert");
      errorBox.style.cssText = [
        "margin-top:12px",
        "padding:12px 14px",
        "border:1px solid #b42318",
        "border-radius:8px",
        "background:#fff1f0",
        "color:#b42318",
        "font-size:14px",
        "font-weight:700"
      ].join(";");
      form.appendChild(errorBox);
    }

    errorBox.textContent = message;
    errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (!form.querySelector('[name="id"]')) return;

      // Run before the Impact theme cart handler, so the cart drawer never opens.
      event.preventDefault();
      event.stopImmediatePropagation();

      if (isSubmitting) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      isSubmitting = true;
      setBusy(form, true);

      try {
        const formData = new FormData(form);
        formData.delete("sections");
        formData.delete("sections_url");

        const response = await fetch(`${shopifyRoot()}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        let responseData = {};
        try {
          responseData = await response.json();
        } catch (_) {
          responseData = {};
        }

        if (!response.ok) {
          throw new Error(
            responseData.description ||
              responseData.message ||
              "This item could not be added. Please check the selected option and try again."
          );
        }

        // Replace avoids returning to a stale product form with the browser Back button.
        window.location.replace(`${shopifyRoot()}checkout`);
      } catch (error) {
        console.error("[Velora Tri-Zone direct checkout]", error);
        isSubmitting = false;
        setBusy(form, false);
        showError(
          form,
          error?.message || "Something went wrong. Please try again."
        );
      }
    },
    true
  );
})();
